import React from "react";
import _ from "lodash";
import { TableCell } from "@material-ui/core";
import { ACCESS_TYPE_PORTFOLIO_DEAL, ACCESS_TYPES } from "constants/accessTypes";

const getAccessLevel = accessTypeId => {
  switch (accessTypeId) {
    case ACCESS_TYPES.ACCESS_TYPE_PORTFOLIO:
    case ACCESS_TYPES.ACCESS_TYPE_PIPELINE:
    case ACCESS_TYPES.ACCESS_TYPE_GROUP:
      return "Full";
    case ACCESS_TYPES.ACCESS_TYPE_PORTFOLIO_DEAL:
    case ACCESS_TYPES.ACCESS_TYPE_PIPELINE_DEALPIPELINE_DEAL:
      return "Deal";
    case ACCESS_TYPES.ACCESS_TYPE_LOAN:
      return "Loan";
    default:
      return null;
  }
};

const buildGuestPermissions = (guestAccess, deal, guestPermission, dealguests, permissionType, history) => {
  let thisGuest = {};
  dealguests.forEach(dealGuest => guestPermission.forEach(permission => {
    if (dealGuest.id === permission.id) {
      thisGuest = dealGuest;
    }
  }));
  if (_.isEmpty(thisGuest) || (thisGuest && thisGuest.id && !thisGuest[permissionType])) {
    history.push("/AccessDenied");

    return null;
  }
  if (guestAccess === "guest" || (guestAccess === "full" && deal.funds[0].companyId !== guestPermission.contact.companyId)) {
    return {
      isGuest: true,
      canView: thisGuest[permissionType] && thisGuest[permissionType].value === "View",
      canEdit: thisGuest[permissionType] && thisGuest[permissionType].value === "Edit",
      canEditDeal: thisGuest[permissionType] && thisGuest[permissionType].value === "Edit" && permissionType !== "pipelinePermission",
      hasRestrictedMetricPermission: thisGuest.portfolioMetricsPermission && thisGuest.portfolioMetricsPermission.value === "Restricted",
      hasFullMetricPermission: thisGuest.portfolioMetricsPermission && thisGuest.portfolioMetricsPermission.value === "Full",
      pipelineAllowQuoteStatus: thisGuest.pipelineAllowQuoteStatus,
      accessLevel: getAccessLevel(thisGuest.accessTypeId)
    };
  }
};

const shouldBuildGuestPermissions = (guestAccess, deal, guestPermission, dealguests) => Boolean(guestAccess) &&
           (
             (guestAccess === "full" && Boolean(deal) && Boolean(deal.funds) && deal.funds.length > 0 && Boolean(deal.funds[0].companyId)) ||
             guestAccess === "guest"
           ) &&
           Boolean(guestPermission) &&
           guestPermission.length > 0 &&
           Boolean(dealguests) &&
           dealguests.length > 0;

const componentAccess = [
  { name: "calculator", accessRequired: "none" },
  { name: "hedgeExpandable", accessRequired: "full" }
];
const isComponentEnabled = (guestPermission, componentName) => {
  // Work in progress... need better way to assign granular permissions
  const derivedPermission = "none";
  const details = _.find(componentAccess, { "name": componentName });

  return details.accessRequired === derivedPermission;
};

const getTableColumns = (guestPermissions, loanTableColumns) => {
  let temp_loanTableColumns = loanTableColumns;
  if (guestPermissions.isGuest) {
    const newMenu = ({ record, callbacks }) => (<TableCell className="loansList_Menu" key="menu" />);
    const menuSL = _.last(loanTableColumns);
    menuSL.Cell = newMenu;
    temp_loanTableColumns = _.slice(loanTableColumns, 0, loanTableColumns.length - 1);
    temp_loanTableColumns.push(menuSL);
  }

  return temp_loanTableColumns;
};
const enableEditButton = (authentication, guestPermissions, permission) => (
  !authentication.isGuest ||
    (authentication.isGuest && guestPermissions && guestPermissions.portfolioPermissionId === permission)
);

export default {
  getAccessLevel,
  buildGuestPermissions,
  shouldBuildGuestPermissions,
  isComponentEnabled,
  getTableColumns,
  enableEditButton
};
